module.exports = __webpack_public_path__ + "images/bannerDE-7e1ea6f55c940a9b98607999a650515d.jpg";